export default __webpack_public_path__ + "static/media/profile-lab.ff3d97f0.jpg";